<script>
	import { getContext, onDestroy } from 'svelte'
	import { slide } from 'svelte/transition'
	import { styles } from '../../library/scripts/styles'
	import { storeElementID, storeData } from '../../library/scripts/Store.svelte'
	import { get_element_tags, get_initial_values, string_to_fontsize } from '../builderUtils'
	import ColorSelector from '../ColorSelector.svelte'
	import SelectValues from '../SelectValues.svelte'
	import SizeSelector from '../SizeSelector.svelte'
	export let width

	const globals = getContext('globals')
	const fsS = globals.fsS
	const fsXS = globals.fsXS
	const icon = globals.icon
	const iconColor = globals.colorDark
	let iconAlignL = globals.colorDark
	let iconAlignC = globals.colorDark
	let iconAlignR = globals.colorDark
	let iconTxtContAlignL = globals.colorDark
	let iconTxtContAlignC = globals.colorDark
	let iconTxtContAlignR = globals.colorDark
	let iconTxtContJustify = globals.colorDark
	let iconValignT = globals.colorDark
	let iconValignC = globals.colorDark
	let iconValignB = globals.colorDark
	let iconWeight = globals.colorDark
	let iconStyle = globals.colorDark
	let iconDeco = globals.colorDark
	let iconStroke = globals.colorDark
	let mainTool = globals.mainTool
	let mainToolHover = globals.mainToolHover
	let subTool = globals.subTool
	let subToolHover = globals.subToolHover
	const iconHover = globals.colorError
	const fontFamily = globals.fontFamily
	const fontSize = globals.fontSize

	let generalTool
	let showTool1
	let showTool2
	let showTool3
	let showTool4
	let showTool5

	let elementID
	let config
	let blocks
	let blockID, columnID, elementTag

	//css selections
	let selectedColor
	let selectedBackground
	let selectedFontFamily
	let selectedFontSize
	let selectedFontOpac
	let selectedBgOpac
	let selectedMarginTop
	let selectedTXTPT
	let selectedTXTPL
	let selectedItemWidth
	let selectedItemHeight
	let selectedMarginBottom
	let selectedPadding
	let selectedItemAlignment = 'flex-start'
	let selectedItemVAlignment = 'center'
	let selectedFontWeight = 'normal'
	let selectedFontStyle = 'normal'
	let selectedFontDeco = 'normal'
	let selectedTTScolor
	let selectedTTSopac
	let selectedTTSx
	let selectedTTSy
	let selectedTTSb
	let selectedCTBR
	let selectedTPT
	let selectedTPL
	let hasImage
	let isLink
	let selectedLinkColor

	//stative ID for getElementById in SelectValues
	let idSelect1 = 'selFont'
	let idSelect2 = 'selSize'
	let idColor1 = '101'
	let idColor2 = '102'
	let idColor3 = '103'
	let idColor4 = '104'
	let idMarginTop = '3'
	let idMarginBottom = '4'
	let idPadding = '5'
	let idTextWidth = '19'
	let idTextHeight = '20'
	let idTitleHeight = '28'
	let idTitleWidth = '31'
	let idBlockTitleHeight = '29'
	let idTitleRadius = '30'
	let idTTSx = '6'
	let idTTSy = '7'
	let idTTSb = '8'
	let idTPT = '9'
	let idTPL = '10'
	let idTXTPT = '11'
	let idTXTPL = '12'

	const stoData = storeData.subscribe((value) => {
		if (value) {
			config = value
			blocks = value.blocks
		}
	})

	const stoElementID = storeElementID.subscribe((value) => {
		elementID = value
	})

	//set the initial css values from config.json
	$: if (elementID.indexOf('title') > -1 || elementID.indexOf('text') > -1 || elementID.indexOf('blockTitle') > -1) {
		const tags = get_element_tags(elementID)
		blockID = tags[0]
		columnID = tags[1]
		elementTag = tags[2]
		const values = get_initial_values(elementID, blocks, tags)
		selectedFontFamily = values[0]
		selectedFontSize = values[1]
		selectedColor = values[2]
		selectedBackground = values[3]
		selectedFontOpac = values[4]
		selectedBgOpac = values[5]
		selectedMarginTop = values[6]
		selectedMarginBottom = values[7]
		selectedPadding = values[8]
		selectedItemAlignment = values[9]
		selectedItemVAlignment = values[10]
		selectedFontWeight = values[11]
		selectedFontStyle = values[12]
		selectedFontDeco = values[13]
		set_fontstyle_initial_value(selectedFontWeight, selectedFontStyle, selectedFontDeco)
		selectedItemWidth = values[14]
		selectedItemHeight = values[15]
		selectedTTScolor = values[16]
		selectedTTSopac = values[17]
		selectedTTSx = values[18]
		selectedTTSy = values[19]
		selectedTTSb = values[20]
		selectedCTBR = values[21]
		selectedItemAlignment[22]

		if (elementID.indexOf('title') > -1 || elementID.indexOf('blockTitle') > -1) {
			selectedTPT = values[23]
			selectedTPL = values[24]
			set_icon_initial_value_vertical(selectedItemVAlignment)
			set_icon_initial_value(selectedItemAlignment)
		}
		if (elementID.indexOf('text') > -1) {
			// set_icon_txt_container_initial_value(values[16])
			selectedTXTPT = values[23]
			selectedTXTPL = values[24]
			set_icon_txt_container_text_initial_value(selectedItemAlignment)
			set_icon_initial_value_vertical(selectedItemVAlignment)
		}

		hasImage = values[25]
		isLink = values[26]
		selectedLinkColor = values[27]
	}

	const set_icon_txt_container_text_initial_value = (v) => {
		if (v) {
			if (v === 'flex-start') {
				iconTxtContAlignL = iconHover
				iconTxtContAlignC = iconColor
				iconTxtContAlignR = iconColor
				iconTxtContJustify = iconColor
				return
			}
			if (v === 'center') {
				iconTxtContAlignL = iconColor
				iconTxtContAlignC = iconHover
				iconTxtContAlignR = iconColor
				iconTxtContJustify = iconColor
				return
			}

			if (v === 'flex-end') {
				iconTxtContAlignL = iconColor
				iconTxtContAlignC = iconColor
				iconTxtContAlignR = iconHover
				iconTxtContJustify = iconColor
				return
			}

			if (v === 'justify') {
				iconTxtContAlignL = iconColor
				iconTxtContAlignC = iconColor
				iconTxtContAlignR = iconColor
				iconTxtContJustify = iconHover
				return
			}
		}
	}

	const set_fontstyle_initial_value = (w, s, d) => {
		if (w === 'bold') iconWeight = iconHover
		if (w === 'normal') iconWeight = iconColor
		if (s === 'italic') iconStyle = iconHover
		if (s === 'normal') iconStyle = iconColor
		if (d === 'none') {
			iconDeco = iconColor
			iconStroke = iconColor
		}
		if (d === 'underline') {
			iconDeco = iconHover
			iconStroke = iconColor
		}
		if (d === 'line-through') {
			iconDeco = iconColor
			iconStroke = iconHover
		}
	}

	const set_icon_initial_value = (v) => {
		if (v) {
			if (v === 'flex-start') {
				iconAlignL = iconHover
				iconAlignC = iconColor
				iconAlignR = iconColor
				return
			}
			if (v === 'center') {
				iconAlignL = iconColor
				iconAlignC = iconHover
				iconAlignR = iconColor
				return
			}

			if (v === 'flex-end') {
				iconAlignL = iconColor
				iconAlignC = iconColor
				iconAlignR = iconHover
				return
			}
		}
	}

	// const set_icon_txt_container_initial_value = (v) => {
	// 	if (v) {
	// 		if (v === 'left') {
	// 			iconAlignL = iconHover
	// 			iconAlignC = iconColor
	// 			iconAlignR = iconColor
	// 			return
	// 		}
	// 		if (v === 'center') {
	// 			iconAlignL = iconColor
	// 			iconAlignC = iconHover
	// 			iconAlignR = iconColor
	// 			return
	// 		}

	// 		if (v === 'right') {
	// 			iconAlignL = iconColor
	// 			iconAlignC = iconColor
	// 			iconAlignR = iconHover
	// 			return
	// 		}
	// 	}
	// }

	const set_icon_initial_value_vertical = (v) => {
		if (v) {
			if (v === 'flex-start') {
				iconValignT = iconHover
				iconValignC = iconColor
				iconValignB = iconColor
				return
			}
			if (v === 'center') {
				iconValignT = iconColor
				iconValignC = iconHover
				iconValignB = iconColor
				return
			}

			if (v === 'flex-end') {
				iconValignT = iconColor
				iconValignC = iconColor
				iconValignB = iconHover
				return
			}
		}
	}

	const set_css_tag = (cssTag, cmd) => {
		let showFont
		if (elementTag.indexOf('Title') > -1) showFont = true
		else if (elementTag.indexOf('Text') > -1) showFont = true
		else showFont = false
		if (showFont) {
			blocks.forEach((block) => {
				if (block.blockName === blockID) {
					if (elementTag === 'BlockTitle') {
						if (cmd === 'fontColor') block.blockTitleFontColor = cssTag
						if (cmd === 'fontBG') block.blockTitleBackgroundColor = cssTag
						if (cmd === 'fontFamily') block.blockTitleFontFamily = cssTag
						if (cmd === 'fontSize') block.blockTitleFontSize = cssTag
						if (cmd === 'fontWeight') block.blockTitleFontWeight = cssTag
						if (cmd === 'fontStyle') block.blockTitleFontStyle = cssTag
						if (cmd === 'fontDecoration') block.blockTitleFontDeco = cssTag
						if (cmd === 'flexAlign') block.blockTitleAlignHorizontal = cssTag
						if (cmd === 'flexValign') block.blockTitleAlignVertical = cssTag
						if (cmd === 'blockTitleHeight') block.blockTitleHeight = cssTag
						if (cmd === 'TSC') block.blockTitleShadowColor = cssTag
						if (cmd === 'TSX') block.blockTitleShadowOffsetX = cssTag
						if (cmd === 'TSY') block.blockTitleShadowOffsetY = cssTag
						if (cmd === 'TSB') block.blockTitleShadowBlur = cssTag
					} else {
						if (elementTag.indexOf('Title') > -1 && elementTag !== 'BlockTitle') {
							if (cmd === 'fontColor') block.content[columnID - 1].titleFontColor = cssTag
							if (cmd === 'linkColor') block.content[columnID - 1].linkHover = cssTag
							if (cmd === 'fontBG') block.content[columnID - 1].titleBackgroundColor = cssTag
							if (cmd === 'fontFamily') block.content[columnID - 1].titleFontFamily = cssTag
							if (cmd === 'fontSize') block.content[columnID - 1].titleFontSize = cssTag
							if (cmd === 'fontWeight') block.content[columnID - 1].titleFontWeight = cssTag
							if (cmd === 'fontStyle') block.content[columnID - 1].titleFontStyle = cssTag
							if (cmd === 'fontDecoration') block.content[columnID - 1].titleFontDeco = cssTag
							if (cmd === 'flexAlign') block.content[columnID - 1].titleAlignHorizontal = cssTag
							if (cmd === 'flexValign') block.content[columnID - 1].titleAlignVertical = cssTag
							if (cmd === 'titleHeight') block.content[columnID - 1].titleHeight = cssTag
							if (cmd === 'titleWidth') block.content[columnID - 1].titleWidth = cssTag
							if (cmd === 'tPT') {
								block.content[columnID - 1].titlePosTop = cssTag
							}
							if (cmd === 'tPL') block.content[columnID - 1].titlePosLeft = cssTag
							if (cmd === 'TSC') block.content[columnID - 1].titleColumnShadowColor = cssTag
							if (cmd === 'TSX') block.content[columnID - 1].titleColumnShadowOffsetX = cssTag
							if (cmd === 'TSY') block.content[columnID - 1].titleColumnShadowOffsetY = cssTag
							if (cmd === 'TSB') block.content[columnID - 1].titleColumnShadowBlur = cssTag
							if (cmd === 'CTBR') block.content[columnID - 1].titleColumnBorderRadius = cssTag
						}
						if (elementTag.indexOf('Text') > -1) {
							if (cmd === 'fontColor') block.content[columnID - 1].textFontColor = cssTag
							if (cmd === 'linkColor') block.content[columnID - 1].linkHover = cssTag
							if (cmd === 'fontBG') block.content[columnID - 1].textBackgroundColor = cssTag
							if (cmd === 'fontFamily') block.content[columnID - 1].textFontFamily = cssTag
							if (cmd === 'fontSize') block.content[columnID - 1].textFontSize = cssTag
							if (cmd === 'fontWeight') block.content[columnID - 1].textFontWeight = cssTag
							if (cmd === 'fontStyle') block.content[columnID - 1].textFontStyle = cssTag
							if (cmd === 'fontDecoration') block.content[columnID - 1].textFontDeco = cssTag
							if (cmd === 'flexAlign') {
								let align
								if (cssTag === 'flex-start') align = 'left'
								if (cssTag === 'center') align = 'center'
								if (cssTag === 'flex-end') align = 'right'
								block.content[columnID - 1].textAlign = align
							}

							if (cmd === 'txtContainerAlign') {
								let align
								if (cssTag === 'flex-start') align = 'left'
								else if (cssTag === 'center') align = 'center'
								else if (cssTag === 'flex-end') align = 'right'
								else align = cssTag
								block.content[columnID - 1].textAlign = align
								block.content[columnID - 1].textAlignHorizontal = cssTag
							}

							if (cmd === 'textAlign') {
								block.content[columnID - 1].textAlign = cssTag
							}
							if (cmd === 'flexValign') block.content[columnID - 1].textAlignVertical = cssTag
							if (cmd === 'textWidth') block.content[columnID - 1].textWidth = cssTag
							if (cmd === 'textHeight') block.content[columnID - 1].textHeight = cssTag
							if (cmd === 'textPT') block.content[columnID - 1].textPosTop = cssTag
							if (cmd === 'textPL') block.content[columnID - 1].textPosLeft = cssTag
						}
					}
				}
			})

			config.blocks = blocks
			storeData.set(config)
		}
	}

	const add_line_break = (cmd, start, end) => {
		let lineBreak
		let newText
		if (cmd === 'linebreak') lineBreak = '\n'
		if (cmd === 'paragraph') lineBreak = '\n\n'
		if (cmd === 'indent') lineBreak = '  '
		let text = document.getElementById(elementID).innerText
		let slice = text.slice(start, end)
		let head = text.slice(0, start)
		let tail = text.slice(end, text.length)
		if (cmd !== 'indent' || cmd !== 'resindent') {
			slice = slice + lineBreak
			newText = head + slice + tail
		}
		if (cmd === 'indent') {
			slice = lineBreak + slice
			const newSlice = slice.replace(/\s+$/, '')
			newText = head + newSlice + tail
		}

		if (cmd === 'resindent') {
			let newSlice = text.substring(start, end)
			let trimSlice = newSlice.trim()
			newText = head + trimSlice + tail
		}

		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.content[columnID - 1].text = newText
			}
		})

		config.blocks = blocks
		storeData.set(config)
	}

	const set_text_PT = (e) => {
		set_css_tag(e.detail.value, 'textPT')
	}

	const set_text_PL = (e) => {
		set_css_tag(e.detail.value, 'textPL')
	}

	const set_text_height = (e) => {
		set_css_tag(e.detail.value, 'textHeight')
	}

	const set_text_width = (e) => {
		set_css_tag(e.detail.value, 'textWidth')
	}

	const set_title_height = (e) => {
		set_css_tag(e.detail.value, 'titleHeight')
	}

	const set_title_width = (e) => {
		set_css_tag(e.detail.value, 'titleWidth')
	}

	const set_title_PT = (e) => {
		set_css_tag(e.detail.value, 'tPT')
	}

	const set_title_PL = (e) => {
		set_css_tag(e.detail.value, 'tPL')
	}

	const set_block_title_height = (e) => {
		set_css_tag(e.detail.value, 'blockTitleHeight')
	}

	const set_font_color = (e) => {
		set_css_tag(e.detail.color, 'fontColor')
	}

	const set_link_color = (e) => {
		set_css_tag(e.detail.color, 'linkColor')
	}

	const set_bg_color = (e) => {
		const hsl = e.detail.color
		set_css_tag(hsl, 'fontBG')
	}

	const set_font_family = (e) => {
		const font = e.detail.font
		set_css_tag(font, 'fontFamily')
	}

	const set_font_size = (e) => {
		const size = string_to_fontsize(e.detail.size)
		set_css_tag(size, 'fontSize')
	}

	const set_font_weight = () => {
		let fW = document.getElementById(elementID).style.fontWeight
		if (fW === '' || fW === 'normal') {
			iconWeight = iconHover
			set_css_tag('bold', 'fontWeight')
		} else {
			iconWeight = iconColor
			set_css_tag('normal', 'fontWeight')
		}
	}

	const set_font_style = () => {
		let fW = document.getElementById(elementID).style.fontStyle
		if (fW === '' || fW === 'normal') {
			iconWeight = iconHover
			set_css_tag('italic', 'fontStyle')
		} else {
			iconWeight = iconColor
			set_css_tag('normal', 'fontStyle')
		}
	}

	const set_font_underline = () => {
		let fW = document.getElementById(elementID).style.textDecoration
		if (fW === '' || fW === 'none' || fW === 'line-through') {
			iconDeco = iconHover
			set_css_tag('underline', 'fontDecoration')
		} else {
			iconDeco = iconColor
			set_css_tag('none', 'fontDecoration')
		}
	}

	const set_font_strikethrough = () => {
		let fW = document.getElementById(elementID).style.textDecoration
		if (fW === '' || fW === 'none' || fW === 'underline') {
			iconStroke = iconHover
			iconStyle = iconColor
			set_css_tag('line-through', 'fontDecoration')
		} else {
			iconStroke = iconColor
			set_css_tag('none', 'fontDecoration')
		}
	}

	const set_flex_align_left = () => {
		if (elementID.indexOf('text') > -1) set_css_tag('left', 'textAlign')
		else set_css_tag('flex-start', 'flexAlign')
	}

	const set_flex_align_center = () => {
		if (elementID.indexOf('text') > -1) set_css_tag('center', 'textAlign')
		else set_css_tag('center', 'flexAlign')
	}

	const set_flex_align_right = () => {
		if (elementID.indexOf('text') > -1) set_css_tag('right', 'textAlign')
		else set_css_tag('flex-end', 'flexAlign')
	}

	const set_txt_container_align_left = () => {
		set_css_tag('flex-start', 'txtContainerAlign')
	}

	const set_txt_container_align_center = () => {
		set_css_tag('center', 'txtContainerAlign')
	}

	const set_txt_container_align_right = () => {
		set_css_tag('flex-end', 'txtContainerAlign')
	}

	const set_txt_container_align_justify = () => {
		set_css_tag('justify', 'txtContainerAlign')
	}

	const set_flex_valign_top = () => {
		set_css_tag('flex-start', 'flexValign')
	}

	const set_flex_valign_center = () => {
		set_css_tag('center', 'flexValign')
	}

	const set_flex_valign_bottom = () => {
		set_css_tag('flex-end', 'flexValign')
	}

	const set_text_shadow_color = (e) => {
		set_css_tag(e.detail.color, 'TSC')
	}

	const set_text_shadow_x = (e) => {
		set_css_tag(e.detail.value, 'TSX')
	}

	const set_text_shadow_y = (e) => {
		set_css_tag(e.detail.value, 'TSY')
	}

	const set_text_shadow_blur = (e) => {
		set_css_tag(e.detail.value, 'TSB')
	}

	const set_column_title_radius = (e) => {
		set_css_tag(e.detail.value, 'CTBR')
	}

	const set_linebreak = () => {
		if (document.getSelection) {
			const selectedText = document.getSelection()
			const start = selectedText.focusOffset
			const end = selectedText.anchorOffset
			if (start === 0 && end === 0) return
			add_line_break('linebreak', start, end)
		}
	}

	const set_paragraph = () => {
		if (document.getSelection) {
			const selectedText = document.getSelection()
			const start = selectedText.focusOffset
			const end = selectedText.anchorOffset
			if (start === 0 && end === 0) return
			add_line_break('paragraph', start, end)
		}
	}

	const set_indent = () => {
		if (document.getSelection) {
			const selectedText = document.getSelection()
			const start = selectedText.focusOffset
			const end = selectedText.anchorOffset
			if (start === 0 && end === 0) return
			add_line_break('indent', start, end)
		}
	}

	const reset_indent = () => {
		const selectedText = document.getSelection()
		const start = selectedText.focusOffset
		const end = selectedText.anchorOffset
		if (start === 0 && end === 0) return
		add_line_break('resindent', start, end)
	}

	const reset_align = () => {
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				const text = block.content[columnID - 1].text.split('\n')
				const newText = text.join('')
				block.content[columnID - 1].text = newText
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_margin_top = (e) => {
		const value = e.detail.value
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				if (elementTag === 'BlockTitle') block.blockTitleMarginTop = value
				if (elementTag.indexOf('Title') > -1 && elementTag !== 'BlockTitle') {
					block.content[columnID - 1].titleMarginTop = value
				}
				if (elementTag.indexOf('Text') > -1) {
					block.content[columnID - 1].textMarginTop = value
				}
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_margin_bottom = (e) => {
		const value = e.detail.value
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				if (elementTag === 'BlockTitle') block.blockTitleMarginBottom = value
				if (elementTag.indexOf('Title') > -1 && elementTag !== 'BlockTitle') {
					block.content[columnID - 1].titleMarginBottom = value
				}
				if (elementTag.indexOf('Text') > -1) {
					block.content[columnID - 1].textMarginBottom = value
				}
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_padding = (e) => {
		const value = e.detail.value
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				if (elementTag === 'BlockTitle') block.blockTitlePadding = value
				if (elementTag.indexOf('Title') > -1 && elementTag !== 'BlockTitle') {
					block.content[columnID - 1].titlePadding = value
				}
				if (elementTag.indexOf('Text') > -1) {
					block.content[columnID - 1].textPadding = value
				}
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const open_tool = (t) => {
		switch (t) {
			case 'generalTool':
				generalTool = generalTool === true ? false : true
				showTool2 = false
				showTool3 = false
				showTool4 = false
				showTool5 = false
				break
			case 1:
				showTool1 = showTool1 === true ? false : true
				break

			case 2:
				showTool2 = showTool2 === true ? false : true
				generalTool = false
				showTool3 = false
				showTool4 = false
				showTool5 = false
				break

			case 3:
				showTool3 = showTool3 === true ? false : true
				generalTool = false
				showTool2 = false
				showTool4 = false
				showTool5 = false
				break

			case 4:
				showTool4 = showTool4 === true ? false : true
				generalTool = false
				showTool3 = false
				showTool2 = false
				showTool5 = false
				break

			case 5:
				showTool5 = showTool5 === true ? false : true
				generalTool = false
				showTool3 = false
				showTool4 = false
				showTool2 = false
				break
		}
	}

	onDestroy(() => {
		stoElementID
		stoData
	})
</script>

{#if config}
	<main use:styles={{ width }}>
		<section>
			<div
				class="part_title mainTool"
				on:click={() => open_tool(1)}
				on:keydown={() => open_tool(1)}
				use:styles={{ mainTool, mainToolHover, fsXS }}
			>
				{#if elementTag.indexOf('Text') > -1}
					TEXT CONTAINER
				{:else}
					TITLE CONTAINER
				{/if}
			</div>
			{#if showTool1}
				<div
					class="part_title subTool"
					on:click={() => open_tool('generalTool')}
					on:keydown={() => open_tool('generalTool')}
					use:styles={{ subTool, subToolHover, fsXS }}
				>
					general
				</div>
				{#if generalTool}
					<div transition:slide={{ duration: 500 }}>
						<div class="sub_title" use:styles={{ fsXS }}>Background</div>
						<ColorSelector
							on:setcolor={set_bg_color}
							on:setopacity={set_bg_color}
							on:settransparent={set_bg_color}
							transparent="1"
							ID={idColor2}
							selectedColor={selectedBackground}
							initialValue={selectedBgOpac}
						/>

						{#if elementTag.indexOf('Text') > -1}
							<div class="sub_title" use:styles={{ fsXS }}>Width</div>

							<SizeSelector
								ID={idTextWidth}
								range="100"
								unit="%"
								initialValue={selectedItemWidth}
								on:sizechange={set_text_width}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Height</div>

							<SizeSelector
								ID={idTextHeight}
								range="100"
								unit="%"
								initialValue={selectedItemHeight}
								on:sizechange={set_text_height}
							/>

							{#if hasImage}
								<div class="sub_title" use:styles={{ fsXS }}>Top</div>

								<SizeSelector
									ID={idTXTPT}
									range="100"
									unit="%"
									initialValue={selectedTXTPT}
									on:sizechange={set_text_PT}
								/>
								<div class="sub_title" use:styles={{ fsXS }}>Left</div>

								<SizeSelector
									ID={idTXTPL}
									range="100"
									unit="%"
									initialValue={selectedTXTPL}
									on:sizechange={set_text_PL}
								/>
							{/if}
						{/if}

						{#if elementTag.indexOf('Title') > -1 && elementTag !== 'BlockTitle'}
							<div class="sub_title" use:styles={{ fsXS }}>Width</div>

							<SizeSelector
								ID={idTitleWidth}
								range="100"
								unit="%"
								initialValue={selectedItemWidth}
								on:sizechange={set_title_width}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Height</div>

							<SizeSelector
								ID={idTitleHeight}
								range="100"
								unit="%"
								initialValue={selectedItemHeight}
								on:sizechange={set_title_height}
							/>
							{#if hasImage}
								<div class="sub_title" use:styles={{ fsXS }}>Top</div>

								<SizeSelector ID={idTPT} range="100" unit="%" initialValue={selectedTPT} on:sizechange={set_title_PT} />

								<div class="sub_title" use:styles={{ fsXS }}>Left</div>
							{/if}

							<SizeSelector ID={idTPL} range="100" unit="%" initialValue={selectedTPL} on:sizechange={set_title_PL} />
						{/if}

						{#if elementTag === 'BlockTitle'}
							<div class="sub_title" use:styles={{ fsXS }}>Height</div>

							<SizeSelector
								ID={idBlockTitleHeight}
								range="300"
								unit="px"
								initialValue={selectedItemHeight}
								on:sizechange={set_block_title_height}
							/>
						{/if}

						<div class="sub_title" use:styles={{ fsXS }}>Margin Top</div>
						<SizeSelector ID={idMarginTop} range="80" initialValue={selectedMarginTop} on:sizechange={set_margin_top} />

						{#if elementTag.indexOf('Title') > -1 && elementTag.indexOf('Title') !== 9}
							<div class="sub_title" use:styles={{ fsXS }}>Margin Bottom</div>
							<SizeSelector
								ID={idMarginBottom}
								range="80"
								initialValue={selectedMarginBottom}
								on:sizechange={set_margin_bottom}
							/>
						{/if}
						<div class="sub_title" use:styles={{ fsXS }}>Padding</div>
						<SizeSelector ID={idPadding} range="5" initialValue={selectedPadding} on:sizechange={set_padding} />

						{#if elementTag.indexOf('Column') > -1 && elementTag.indexOf('Title') > -1}
							<div class="sub_title" use:styles={{ fsXS }}>Top Radius</div>
							<SizeSelector
								ID={idTitleRadius}
								range="20"
								unit="px"
								initialValue={selectedCTBR}
								on:sizechange={set_column_title_radius}
							/>
						{/if}
					</div>
				{/if}
				<div
					class="part_title subTool"
					on:click={() => open_tool(2)}
					on:keydown={() => open_tool(2)}
					use:styles={{ subTool, subToolHover, fsXS }}
				>
					font
				</div>
				{#if showTool2}
					<div transition:slide={{ duration: 500 }}>
						<div class="sub_title" use:styles={{ fsXS }}>Color</div>
						<ColorSelector
							on:setcolor={set_font_color}
							on:setopacity={set_font_color}
							ID={idColor1}
							{selectedColor}
							initialValue={selectedFontOpac}
						/>

						{#if isLink}
							<div class="sub_title" use:styles={{ fsXS }}>Link Color</div>
							<ColorSelector on:setcolor={set_link_color} ID={idColor4} selectedColor={selectedLinkColor} />
						{/if}

						<div class="sub_title" use:styles={{ fsXS }}>Font Family</div>
						<SelectValues options={fontFamily} on:select={set_font_family} value={selectedFontFamily} ID={idSelect1} />
						<div class="sub_title" use:styles={{ fsXS }}>Font Size</div>
						<SelectValues options={fontSize} on:select={set_font_size} value={selectedFontSize} ID={idSelect2} />

						<div class="sub_title" use:styles={{ fsXS }}>Font Decoration</div>
						<div class="icon_container">
							<div
								id="fweight"
								class="icon iconWeight"
								use:styles={{ icon, iconWeight, iconHover }}
								on:click={set_font_weight}
								on:keydown={set_font_weight}
							/>
							<div
								id="fstyle"
								class="icon iconStyle"
								use:styles={{ icon, iconStyle, iconHover }}
								on:click={set_font_style}
								on:keydown={set_font_style}
							/>
							<div
								id="fdeco"
								class="icon iconDeco"
								use:styles={{ icon, iconDeco, iconHover }}
								on:click={set_font_underline}
								on:keydown={set_font_underline}
							/>
							<div
								id="fstroke"
								class="icon iconStroke"
								use:styles={{ icon, iconStroke, iconHover }}
								on:click={set_font_strikethrough}
								on:keydown={set_font_strikethrough}
							/>
						</div>
					</div>
				{/if}

				<div
					class="part_title subTool"
					on:click={() => open_tool(3)}
					on:keydown={() => open_tool(3)}
					use:styles={{ subTool, subToolHover, fsXS }}
				>
					alignment
				</div>
				{#if showTool3}
					<div transition:slide={{ duration: 500 }}>
						<div class="icon_container">
							{#if elementTag.indexOf('Title') > -1}
								<div
									id="fAlignL"
									class="icon txtAlignL"
									use:styles={{ icon, iconAlignL, iconHover }}
									on:click={set_flex_align_left}
									on:keydown={set_flex_align_left}
								/>

								<div
									id="fAlignC"
									class="icon txtAlignC"
									use:styles={{ icon, iconAlignC, iconHover }}
									on:click={set_flex_align_center}
									on:keydown={set_flex_align_center}
								/>

								<div
									id="fAlignR"
									class="icon txtAlignR"
									use:styles={{ icon, iconAlignR, iconHover }}
									on:click={set_flex_align_right}
									on:keydown={set_flex_align_right}
								/>
							{/if}

							{#if elementTag.indexOf('Text') > -1}
								<div
									id="cAlignL"
									class="icon txtContAlignL"
									use:styles={{ icon, iconTxtContAlignL, iconHover }}
									on:click={set_txt_container_align_left}
									on:keydown={set_txt_container_align_left}
								/>

								<div
									id="cAlignC"
									class="icon txtContAlignC"
									use:styles={{ icon, iconTxtContAlignC, iconHover }}
									on:click={set_txt_container_align_center}
									on:keydown={set_txt_container_align_center}
								/>

								<div
									id="cAlignR"
									class="icon txtContAlignR"
									use:styles={{ icon, iconTxtContAlignR, iconHover }}
									on:click={set_txt_container_align_right}
									on:keydown={set_txt_container_align_right}
								/>

								<div
									id="fAlignJ"
									class="icon txtContJustify"
									use:styles={{ icon, iconTxtContJustify, iconHover }}
									on:click={set_txt_container_align_justify}
									on:keydown={set_txt_container_align_justify}
								/>
							{/if}
						</div>

						<div class="icon_container">
							<div
								id="vAlignT"
								class="icon txtValignT"
								use:styles={{ icon, iconValignT, iconHover }}
								on:click={set_flex_valign_top}
								on:keydown={set_flex_valign_top}
							/>

							<div
								id="vAlignC"
								class="icon txtValignC"
								use:styles={{ icon, iconValignC, iconHover }}
								on:click={set_flex_valign_center}
								on:keydown={set_flex_valign_center}
							/>

							<div
								id="vAlignB"
								class="icon txtValignB"
								use:styles={{ icon, iconValignB, iconHover }}
								on:click={set_flex_valign_bottom}
								on:keydown={set_flex_valign_bottom}
							/>
							{#if elementTag.indexOf('Text') > -1}
								<div />
							{/if}
						</div>
					</div>
				{/if}
				{#if elementTag.indexOf('Text') > -1}
					<div
						class="part_title subTool"
						on:click={() => open_tool(4)}
						on:keydown={() => open_tool(4)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						paragraph
					</div>
					{#if showTool4}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Paragraph</div>
							<div class="icon_container">
								<div
									id="lb"
									class="icon linebreak"
									use:styles={{ icon, iconColor, iconHover }}
									on:click={set_linebreak}
									on:keydown={set_linebreak}
								/>

								<div
									id="paragraph"
									class="icon paragraph"
									use:styles={{ icon, iconColor, iconHover }}
									on:click={set_paragraph}
									on:keydown={set_paragraph}
								/>

								<div
									id="indent"
									class="icon indent"
									use:styles={{ icon, iconColor, iconHover }}
									data-indent
									on:click={set_indent}
									on:keydown={set_indent}
								/>

								<div
									id="resIndent"
									class="icon resIndent"
									use:styles={{ icon, iconColor, iconHover }}
									on:click={reset_indent}
									on:keydown={reset_indent}
								/>
								<div
									id="resAlign"
									class="icon resAlign"
									use:styles={{ icon, iconColor, iconHover }}
									on:click={reset_align}
									on:keydown={reset_align}
								/>
							</div>
						</div>
					{/if}
				{/if}

				{#if elementTag.indexOf('Title') > -1}
					<div
						class="part_title subTool"
						on:click={() => open_tool(5)}
						on:keydown={() => open_tool(5)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						shadow
					</div>
					{#if showTool5}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Shadow Color</div>
							<ColorSelector
								on:setcolor={set_text_shadow_color}
								on:setopacity={set_text_shadow_color}
								ID={idColor3}
								selectedColor={selectedTTScolor}
								initialValue={selectedTTSopac}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Offset X</div>
							<SizeSelector
								ID={idTTSx}
								initialValue={selectedTTSx}
								range="40"
								unit="px"
								on:sizechange={set_text_shadow_x}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Offset Y</div>
							<SizeSelector
								ID={idTTSy}
								initialValue={selectedTTSy}
								range="40"
								unit="px"
								on:sizechange={set_text_shadow_y}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Blur</div>
							<SizeSelector
								ID={idTTSb}
								initialValue={selectedTTSb}
								range="20"
								unit="px"
								on:sizechange={set_text_shadow_blur}
							/>
						</div>
					{/if}
				{/if}
			{/if}
		</section>
	</main>
{/if}

<style>
	main {
		width: var(--with);
		user-select: none;
	}

	.sub_title {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		background: hsl(0, 0%, 70%);
		color: black;
		padding: 10px;
		border-bottom: 1px solid black;
	}

	.part_title {
		display: flex;
		width: 100%;
		justify-content: center;
		border-bottom: none;
		font-size: var(--fsXS);
		font-weight: bold;
		background-color: chocolate;
		padding: 10px;
		margin-top: 10px;
		cursor: pointer;
	}

	.sub_title {
		font-size: var(--fsXS);
		border-bottom: none;
		padding: 10px 0px 3px 10px;
	}

	.icon_container {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(40px, 1fr));
		padding: 2%;
	}

	.icon {
		display: inline-block;
		width: var(--icon);
		height: var(--icon);
		mask-size: cover;
		-webkit-mask-size: cover;
		cursor: pointer;
	}

	.icon:hover {
		background-color: var(--iconHover);
	}

	.iconWeight {
		background-color: var(--iconWeight);
		mask: url('/images/tools/fontB.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontB.svg') no-repeat;
	}

	.iconStyle {
		background-color: var(--iconStyle);
		mask: url('/images/tools/fontI.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontI.svg') no-repeat;
	}

	.iconDeco {
		background-color: var(--iconDeco);
		mask: url('/images/tools/fontU.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontU.svg') no-repeat;
	}

	.iconStroke {
		background-color: var(--iconStroke);
		mask: url('/images/tools/fontST.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontST.svg') no-repeat;
	}

	.txtAlignL {
		background-color: var(--iconAlignL);
		mask: url('/images/tools/alignL.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignL.svg') no-repeat;
	}

	.txtAlignC {
		background-color: var(--iconAlignC);
		mask: url('/images/tools/alignC.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignC.svg') no-repeat;
	}

	.txtAlignR {
		background-color: var(--iconAlignR);
		mask: url('/images/tools/alignR.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignR.svg') no-repeat;
	}

	.txtContAlignL {
		background-color: var(--iconTxtContAlignL);
		mask: url('/images/tools/alignL.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignL.svg') no-repeat;
	}

	.txtContAlignC {
		background-color: var(--iconTxtContAlignC);
		mask: url('/images/tools/alignC.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignC.svg') no-repeat;
	}

	.txtContAlignR {
		background-color: var(--iconTxtContAlignR);
		mask: url('/images/tools/alignR.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignR.svg') no-repeat;
	}

	.txtContJustify {
		background-color: var(--iconTxtContJustify);
		mask: url('/images/tools/alignJ.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignJ.svg') no-repeat;
	}

	.txtValignT {
		background-color: var(--iconValignT);
		mask: url('/images/tools/valignT.svg') no-repeat;
		-webkit-mask: url('/images/tools/valignT.svg') no-repeat;
	}

	.txtValignC {
		background-color: var(--iconValignC);
		mask: url('/images/tools/valignC.svg') no-repeat;
		-webkit-mask: url('/images/tools/valignC.svg') no-repeat;
	}

	.txtValignB {
		background-color: var(--iconValignB);
		mask: url('/images/tools/valignB.svg') no-repeat;
		-webkit-mask: url('/images/tools/valignB.svg') no-repeat;
	}

	.linebreak {
		background-color: var(--iconColor);
		mask: url('/images/tools/lb.svg') no-repeat;
		-webkit-mask: url('/images/tools/lb.svg') no-repeat;
	}

	.paragraph {
		background-color: var(--iconColor);
		mask: url('/images/tools/para.svg') no-repeat;
		-webkit-mask: url('/images/tools/para.svg') no-repeat;
	}

	.indent {
		background-color: var(--iconColor);
		mask: url('/images/tools/indent.svg') no-repeat;
		-webkit-mask: url('/images/tools/indent.svg') no-repeat;
	}

	.resIndent {
		background-color: var(--iconColor);
		mask: url('/images/tools/resIndent.svg') no-repeat;
		-webkit-mask: url('/images/tools/resIndent.svg') no-repeat;
	}

	.resAlign {
		background-color: var(--iconColor);
		mask: url('/images/tools/alignReset.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignReset.svg') no-repeat;
	}

	.mainTool {
		background-color: var(--mainTool);
	}

	.mainTool:hover {
		background-color: var(--mainToolHover);
	}

	.subTool {
		background-color: var(--subTool);
	}

	.subTool:hover {
		background-color: var(--subToolHover);
	}
</style>
